import { skipToken, useQuery } from "@tanstack/react-query";

import { clientChangeHistoryApi } from "@/api";
import { QueryKey } from "@/query/Query";

import { ChangeHistoryScope } from "./useChangeHistoryScope";

export function useClientChangeInfo(clientId: string | undefined, scope: ChangeHistoryScope | undefined) {
  // Deliberately no meta.loadingScope — the info line must never block the page or the save UX.
  return useQuery({
    queryKey: [QueryKey.ClientChangeInfo, clientId, scope?.section, scope?.entryId],
    queryFn:
      clientId && scope
        ? () =>
            clientChangeHistoryApi.getClientChangeInfo({
              clientId,
              section: scope.section,
              entryId: scope.entryId,
            })
        : skipToken,
    // The backend recomputes the whole section diff per call, so without this every tab switch would
    // re-run it. Version rows change only through a save, and useInvalidateChangeHistoryOnSave
    // invalidates this client's key after one succeeds.
    staleTime: Infinity,
  });
}
